import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TotalRevenueHotel } from 'lumen/models';
import type {
  Category,
  SubCategory,
} from 'lumen/utils/constants/transaction-mapping/constants';

export default class TransactionMappingItem extends Model {
  [Type] = 'transaction-mapping/item' as const;

  @belongsTo('total-revenue/hotel', { async: false, inverse: null })
  declare subscription: TotalRevenueHotel;

  @attr('string') declare ourCategory: Category;
  @attr('string') declare ourSubCategory: SubCategory;
  @attr('string') declare pmsCategory: string;
  @attr('string') declare pmsDescription: string;
  @attr('string') declare pmsSubCategory: string;
  @attr('string') declare transactionCode: string;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotelName() {
    return this.subscription.name;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isUnmapped() {
    return (
      this.ourCategory === 'unmapped' && this.ourSubCategory === 'unmapped'
    );
  }
}
